import { ILogger } from "by/gamefactory/cityversetycoon/logger/ILogger";
import { IAnalyticProviderWrapper } from "../../../../../analytics/IAnalyticProviderWrapper";
import { ICanvasScaler } from "../../../../../canvas/ICanvasScaler";
import { PromiseCompletionSource } from "../../../../../shared/async/PromiseCompletionSource";
import { BaseScalableView } from "../../../common/BaseScalableView";
import { CommonResourcesPackage } from "../../../common/resources/CommonResourcesPackage";
import { TopPanel } from "../../../game/components/toppanel/TopPanel";
import { PushDialogData } from "../../../game/flow/impl/dialogAction/PushDialogData";
import { IPushController } from "../controllers/IPushController";
import { PushResourcePackage } from "../resources/PushResourcePackage";
import { MainPage } from "./pages/MainPage";
import { SecondaryPage } from "./pages/SecondaryPage";
import { Sprite } from "pixi.js";

export class PushPopupView extends BaseScalableView<void> {
    private readonly pushResources: PushResourcePackage;
    private readonly commonResources: CommonResourcesPackage;
    private readonly pushController: IPushController;
    private readonly topPanel: TopPanel;
    private readonly analyticProvider: IAnalyticProviderWrapper;
    private readonly dialogData: PushDialogData;
    private readonly logger: ILogger;

    public constructor(
        operationControls: PromiseCompletionSource<void>,
        canvasScaler: ICanvasScaler,
        pushResources: PushResourcePackage,
        commonResources: CommonResourcesPackage,
        pushController: IPushController,
        analyticProvider: IAnalyticProviderWrapper,
        topPanel: TopPanel,
        dialogData: PushDialogData,
        logger: ILogger
    ) {
        super(operationControls, canvasScaler);
        this.pushResources = pushResources;
        this.commonResources = commonResources;
        this.pushController = pushController;
        this.analyticProvider = analyticProvider;
        this.topPanel = topPanel;
        this.dialogData = dialogData;
        this.logger = logger;
    }

    public async start(): Promise<void> {
        const viewBackground = new Sprite(this.commonResources.assets_common_blured_backgrounds_blurry_lobby_jpg);
        viewBackground.eventMode = "static";
        this.addChild(viewBackground);
        const mainPageCS = new PromiseCompletionSource<boolean>();
        const mainPage = new MainPage(
            mainPageCS,
            this.canvasScaler,
            this.pushResources,
            this.commonResources,
            this.dialogData,
            this.analyticProvider
        );
        this.addChild(mainPage);
        const result = await mainPageCS.result;
        if (result) {
            this.removeChild(mainPage);
            const secondaryPageCS = new PromiseCompletionSource<void>();
            const secondaryPage = new SecondaryPage(
                secondaryPageCS,
                this.canvasScaler,
                this.pushResources,
                this.commonResources,
                this.pushController,
                this.analyticProvider,
                this.topPanel,
                this.dialogData,
                this.logger
            );
            this.addChild(secondaryPage);
            await secondaryPageCS.result;
            this.removeChild(secondaryPage);
        }
        this.operationControls.complete();
    }
}